var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviders = function SvgProviders(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V6C22 4.89543 21.1046 4 20 4L4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18Z",
    stroke: "#4A4E55",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5C7 11.0304 7.21062 11.5391 7.58569 11.9142C7.96077 12.2893 8.46957 12.5 9 12.5C9.53043 12.5 10.039 12.2893 10.4141 11.9142C10.7891 11.5391 11 11.0304 11 10.5V9.5C11 8.96957 10.7891 8.46086 10.4141 8.08578C10.039 7.71071 9.53043 7.5 9 7.5C8.46957 7.5 7.96077 7.71071 7.58569 8.08578C7.21062 8.46086 7 8.96957 7 9.5V10.5Z",
    fill: "#4A4E55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C12.7177 15.6523 12.1835 14.911 11.4688 14.3749C10.754 13.8389 9.8928 13.5336 9 13.5C8.1072 13.5336 7.24599 13.8389 6.53125 14.3749C5.81651 14.911 5.28225 15.6523 5 16.5",
    fill: "#4A4E55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H14",
    stroke: "#4A4E55",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1271_2822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 14H14",
    stroke: "#4A4E55",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1271_2822",
    x: 10,
    y: 13,
    width: 11,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1271_2822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1271_2822",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "providers.944b68b4d0c1233cf59fb9dda18720f8.svg";